import GroupConfigurationSearchableDropdown from '@/Components/Common/GroupConfigurationSearchableDropdown'
import { Button } from '@/Components/ui/button'
import { Checkbox } from '@/Components/ui/checkbox'
import { Input } from '@/Components/ui/input'
import { useAuth } from '@/Context/AuthContext'
import GroupConfigurationTabEnum from '@/Enums/GroupConfigurationTabEnum'
import GroupConfigurationService from '@/Service/GroupConfigurationService'
import Constant from '@/utils/Constant'
import { generateRandomeString } from '@/utils/helper'
import { Plus, Trash2 } from 'lucide-react'
import React, { useEffect, useReducer } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useDebounce } from 'use-debounce'

const EmployeeAllocations = ({ currentRole, employee }) => {
    const [event, updateEvent] = useReducer(
        (prev, next) => {
            if (next?.groupAllEmployeeChecked !== undefined && Object.keys(prev.employeeConfigurationGroupWise).length) {
                let groups = Object.keys(next?.groupAllEmployeeChecked)
                if (groups.length) {
                    groups.forEach((group) => {
                        if (Object.keys(prev.employeeConfigurationGroupWise).includes(group)) {
                            prev.employeeConfigurationGroupWise[group] = prev.employeeConfigurationGroupWise[group].map((employee) => {
                                employee['checkbox'] = next?.groupAllEmployeeChecked[group]
                                return employee
                            })
                        }
                    })
                }
            }
            return { ...prev, ...next }
        },
        {
            allGroupConfigurations: [],
            employeeConfigurationGroupWise: {},
            groupAllEmployeeChecked: {},
            employee: [],
            groupSearch: '',
            isOpen: false,
            priorityChangeEvent: 0,
        }
    )

    const [priorityChangeDebounced] = useDebounce(event.priorityChangeEvent, Constant.DEBOUNCE_DELAY)
    const handleAddEmployeToGroup = (groupName) => {
        updateEvent({
            employeeConfigurationGroupWise: {
                ...event.employeeConfigurationGroupWise,
                [groupName]: [
                    ...event.   employeeConfigurationGroupWise[groupName],
                    {
                        diff_name: generateRandomeString(),
                        priority: 1,
                        employee_email: '',
                        employee_name: '',
                        sampling: 1,
                    },
                ],
            },
        })
    }

    const handleDeleteEmployeToGroup = (groupName) => {
        let currentEmployeeConfig = {
            ...event.employeeConfigurationGroupWise,
            [groupName]: event.employeeConfigurationGroupWise[groupName].filter((employee) => !employee.checkbox),
        }
        updateEvent({ employeeConfigurationGroupWise: currentEmployeeConfig })
        handleUpdateEmployeeAllocation(currentEmployeeConfig)
    }

    const getAllGroupConfigurations = async () => {
        updateEvent({ isDataFetching: true })
        try {
            const resp = await GroupConfigurationService.getAllGroupConfigurations({ role: currentRole })
            if (resp.data.success) {
                let employeeDataGroupWise = {}
                let groupAllEmployeeDefaultCheckFalse = {}
                resp.data.data.forEach((group) => {
                    groupAllEmployeeDefaultCheckFalse[group.name] = false
                    employeeDataGroupWise[group.name] = group.employee_table.map((employee) => {
                        employee['checkbox'] = false
                        return employee
                    })
                })
                updateEvent({
                    groupAllEmployeeChecked: groupAllEmployeeDefaultCheckFalse,
                    allGroupConfigurations: resp.data.data,
                    employeeConfigurationGroupWise: employeeDataGroupWise,
                })
            }
        } catch (err) {}
        updateEvent({ isDataFetching: false })
    }

    const handleUpdateEmployeeAllocation = async (currentEmployeeConfig) => {
        try {
            let groupEmployee = []
            event.allGroupConfigurations.forEach((group) => {
                let employee_data = []
                let ErrorReturned = false
                currentEmployeeConfig[group.name].forEach((emp) => {
                    if (emp.priority == '') {
                        ErrorReturned = true
                        return false
                    }
                    delete emp.diff_name
                    if (emp.employee_email !== '') {
                        employee_data.push(emp)
                    }
                })
                if (ErrorReturned) return false

                groupEmployee.push({
                    name: group.name,
                    employee_data,
                })
            })
            let postData = {
                group_employee: groupEmployee,
            }
            const resp = await GroupConfigurationService.updateGroupEmployeeAllocation(postData)
            if (resp.data.success) {
                await getAllGroupConfigurations()
            }
        } catch (err) {
            console.log('error', err)
        }
    }

    useEffect(() => {
        getUserByRoles()
        getAllGroupConfigurations()
    }, [currentRole])

    useEffect(() => {
        let groups = Object.keys(event.employeeConfigurationGroupWise)
        let isPriorityEmpty = false
        for (let i = 0; i < groups.length; i++) {
            if (event.employeeConfigurationGroupWise[groups[i]].some((employee) => employee.priority == '')) {
                isPriorityEmpty = true
                break
            }
        }
        if (!isPriorityEmpty && priorityChangeDebounced > 0) {
            handleUpdateEmployeeAllocation(event.employeeConfigurationGroupWise)
        }
    }, [priorityChangeDebounced])

    const renderTable = (groupData, groupName) => {
        if (!groupData) {
            return null
        }
        return (
            <div
                className="overflow-auto overflow-card-scroll"
                style={{
                    maxHeight: 'calc(100vh - 300px)',
                    marginBottom: '2px',
                }}
            >
                <table className="w-full rounded-md">
                    <thead className="bg-blue-100 sticky top-0 ">
                        <tr className="">
                            <td className=" text-[12px] w-[10%] font-bold py-2 px-1 text-center">
                                <Checkbox
                                    checked={event.groupAllEmployeeChecked[groupName]}
                                    onCheckedChange={(isChecked) => {
                                        updateEvent({
                                            groupAllEmployeeChecked: {
                                                ...event.groupAllEmployeeChecked,
                                                [groupName]: isChecked,
                                            },
                                        })
                                    }}
                                />
                            </td>
                            <td className=" text-[12px] w-[80%] font-bold py-2 px-1 text-left">Employee Name</td>
                            <td className=" text-[12px] w-[5%] font-bold py-2 px-1 text-center">Priority</td>
                            <td className=" text-[12px] w-[5%] font-bold py-2 px-2 text-center">Sampling</td>
                        </tr>
                    </thead>
                    <tbody onDragOver={allowDrop} onDrop={(e) => handleDrop(e, groupName)}>
                        {groupData.length > 0 ? (
                            groupData.map((item, employeeIndex) => (
                                <tr
                                    key={groupName + '-' + (item?.name ? item?.name : item?.diff_name)}
                                    id={item?.name ? item?.name : item?.diff_name}
                                    draggable
                                    onDragStart={(e) => handleDragStart(e, item, groupName)}
                                    className="cursor-move hover:shadow-md"
                                >
                                    <td className=" text-[12px] py-2 px-1 text-center">
                                        <Checkbox
                                            checked={item?.checkbox}
                                            onCheckedChange={(isChecked) =>
                                                updateEvent({
                                                    employeeConfigurationGroupWise: {
                                                        ...event.employeeConfigurationGroupWise,
                                                        [groupName]: event.employeeConfigurationGroupWise[groupName].map((employee, i) => {
                                                            if (employeeIndex == i) {
                                                                employee['checkbox'] = isChecked
                                                            }
                                                            return employee
                                                        }),
                                                    },
                                                })
                                            }
                                        />
                                    </td>
                                    <td className=" text-[12px] py-2 px-0">
                                        <GroupConfigurationSearchableDropdown
                                            options={event.employee.filter(
                                                (employee) =>
                                                    !event.employeeConfigurationGroupWise[groupName]
                                                        .map((emp) => emp.employee_email)
                                                        .includes(employee.email)
                                            )}
                                            selectedValue={item?.employee_name}
                                            searchFilter={{
                                                role: event.currentRole,
                                                selectedEmployee: event.employeeConfigurationGroupWise[groupName]
                                                    .map((emp) => emp.employee_email)
                                                    .toString(),
                                            }}
                                            handleSelected={(_, val) => {
                                                let currentEmployeeConfig = {
                                                    ...event.employeeConfigurationGroupWise,
                                                    [groupName]: event.employeeConfigurationGroupWise[groupName].map((employee, i) => {
                                                        if (employeeIndex == i) {
                                                            employee['employee_email'] = val.email
                                                            employee['employee_name'] = val.full_name
                                                        }
                                                        return employee
                                                    }),
                                                }
                                                updateEvent({ employeeConfigurationGroupWise: currentEmployeeConfig })
                                                handleUpdateEmployeeAllocation(currentEmployeeConfig)
                                            }}
                                        />
                                    </td>
                                    <td className=" text-[12px] py-2 px-1 text-center">
                                        <Input
                                            type="number"
                                            className="text-center border-0 focus:outline-none shadow-none "
                                            value={item?.priority}
                                            onChange={(e) => {
                                                let currentPriority = e.target.value
                                                if (event.allGroupConfigurations.length < currentPriority) {
                                                    toast.error('Maximum Priority allowed ' + event.allGroupConfigurations.length)
                                                    currentPriority = 1
                                                    return
                                                }
                                                updateEvent({
                                                    priorityChangeEvent: Date.now(),
                                                    employeeConfigurationGroupWise: {
                                                        ...event.employeeConfigurationGroupWise,
                                                        [groupName]: event.employeeConfigurationGroupWise[groupName].map((employee, i) => {
                                                            if (employeeIndex == i) {
                                                                employee['priority'] = currentPriority
                                                            }
                                                            return employee
                                                        }),
                                                    },
                                                })
                                            }}
                                        />
                                    </td>
                                    <td className=" text-[12px] py-2 px-1 text-center">
                                        <Input
                                            type="number"
                                            className="text-center border-0 focus:outline-none shadow-none "
                                            value={item?.sampling}
                                            onChange={(e) => {
                                                let currentSampling = e.target.value
                                                if (event.allGroupConfigurations.length < currentSampling) {
                                                    toast.error('Maximum Priority allowed ' + event.allGroupConfigurations.length)
                                                    currentSampling = 0
                                                    return
                                                }
                                                updateEvent({
                                                    priorityChangeEvent: Date.now(),
                                                    employeeConfigurationGroupWise: {
                                                        ...event.employeeConfigurationGroupWise,
                                                        [groupName]: event.employeeConfigurationGroupWise[groupName].map((employee, i) => {
                                                            if (employeeIndex == i) {
                                                                employee['sampling'] = currentSampling
                                                            }
                                                            return employee
                                                        }),
                                                    },
                                                })
                                            }}
                                        />
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr className=" h-12 text-center text-[12px] text-gray-400">
                                <td colSpan="4">Drop or Add items here</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        )
    }

    const getUserByRoles = async () => {
        try {
            let postData = {
                role: currentRole,
            }
            const resp = await UserService.getUsersByRole(postData)
            if (resp.data.success) {
                updateEvent({ employee: resp.data.data })
            }
        } catch (err) {}
    }

    const allowDrop = (e) => {
        e.preventDefault()
    }

    const handleDragStart = (e, item, fromGroup) => {
        e.dataTransfer.setData('item_id', item?.name ? item.name : item?.diff_name)
        e.dataTransfer.setData('employee_email', item.employee_email)
        e.dataTransfer.setData('from_group', fromGroup)
    }

    const handleDrop = (e, toGroup) => {
        e.preventDefault()
        const itemId = e.dataTransfer.getData('item_id')
        const employee_email = e.dataTransfer.getData('employee_email')
        const fromGroup = e.dataTransfer.getData('from_group')
        let isEmployeeAlreadyExistInToGroup = event.employeeConfigurationGroupWise[toGroup].some((i) => i.employee_email === employee_email)
        if (toGroup == fromGroup) {
            return
        }
        if (isEmployeeAlreadyExistInToGroup) {
            toast.error('Duplicate Employee Not Allowed')
            return
        }
        let item = event.employeeConfigurationGroupWise[fromGroup].find((i) => (i?.name ? i.name : i?.diff_name) === itemId)
        let currentEmployeeConfig = {
            ...event.employeeConfigurationGroupWise,
            [fromGroup]: event.employeeConfigurationGroupWise[fromGroup].filter((i) => (i?.name ? i.name : i?.diff_name) !== itemId),
            [toGroup]: [...event.employeeConfigurationGroupWise[toGroup], item],
        }
        updateEvent({ employeeConfigurationGroupWise: currentEmployeeConfig })
        handleUpdateEmployeeAllocation(currentEmployeeConfig)
    }

    return (
        <div className="border flex gap-4 shadow-inner rounded-md  h-full p-2 mt-3 overflow-auto">
            {event.allGroupConfigurations.length > 0 ? (
                event.allGroupConfigurations.map((groupConfig) => {
                    return (
                        <div key={groupConfig.name} className="min-w-[32%] w-[32%] shadow-md bg-gray-50  h-full overflow-hidden p-2">
                            <div className="w-full text-center text-[14px] font-bold text-gray-600 mb-3  mt-2">{groupConfig.name}</div>
                            <div className="shadow-md bg-white rounded-md w-full">
                                {renderTable(event.employeeConfigurationGroupWise[groupConfig.name], groupConfig.name)}
                                <div className="w-[100%] flex">
                                    <Button
                                        className=" hover:bg-green-600 w-[50%] hover:text-white text-center  bg-transparent  text-gray-700 font-semibold  text-[12px] rounded-none  flex justify-center rounded-tr-none rounded-tl-none h-fit py-2"
                                        onClick={() => handleAddEmployeToGroup(groupConfig.name)}
                                    >
                                        <Plus /> Add
                                    </Button>
                                    {event.employeeConfigurationGroupWise[groupConfig.name] &&
                                        event.employeeConfigurationGroupWise[groupConfig.name].some((val) => val.checkbox) && (
                                            <Button
                                                className=" hover:bg-red-600 w-[50%]  bg-transparent hover:text-white text-gray-700 font-semibold  text-[12px] rounded-none flex justify-center rounded-tr-none rounded-tl-none h-fit py-2"
                                                onClick={() => handleDeleteEmployeToGroup(groupConfig.name)}
                                            >
                                                <Trash2 /> Delete
                                            </Button>
                                        )}
                                </div>
                            </div>
                        </div>
                    )
                })
            ) : (
                <div key={'GroupNotFound'} className="w-full shadow-md bg-gray-50  h-full flex justify-center items-center overflow-hidden p-2">
                    <div className="flex flex-col justify-center items-center gap-2">
                        <span className="text-gray-400 text-2xl">No Group Configurations Found</span>
                        <Link to={'/configuration/group-configuration/new?role=' + currentRole} className="text-purple-700">
                            Add Group Configuration
                        </Link>
                    </div>
                </div>
            )}
        </div>
    )
}

export default EmployeeAllocations
